module.exports = __webpack_public_path__ + "img/flags.c7f91c31.png";